module.exports = __webpack_public_path__ + "static/media/ji.92f22945.png";